import {
  DISPLAY_COLOR_NO_FILL,
  FacetTypes,
  PALETTE_ATTRIBUTE_STRING,
  PALETTE_ATTRIBUTE_STRINGLIST,
  UNCLASSIFIED } from
"./Facets";
import { AttributeType } from "../schema/Attribute";

export const MultipleMepSystemsFacetColorId = FacetTypes.mepSystems + ":multiple";
export const MultipleRoomsFacetColorId = FacetTypes.spaces + ":multiple";

export class PaletteGenerator {

  constructor() {
    this.color = new THREE.Color();
    this.hue = 0; // [0, 360]
    this.hueI = 0; // [0, 10]
    this.saturation = 100; // [30, 100]
    this.lightness = 75; // [25, 75]
  }

  next() {
    // Palette is "consumed": generate differentiable colors
    this.color.setHSL(this.hue / 360, this.saturation / 100, this.lightness / 100);
    let colorHex = '#' + this.color.getHexString();

    // tweak hue, saturation and lightness to generate colors:
    // - increment by the "golden angle" (~= 137 deg): next colors are distinguishable and it's not a divisor of 360
    // - decrement saturation every 10 colors
    // - decrement lightness every 70 colors
    this.hue = (this.hue + 137) % 360;
    this.hueI += 1;
    if (this.hueI === 10) {
      this.hueI = 0;
      this.saturation -= 10;
      // Saturation below 30% is too grey
      if (this.saturation === 30) {
        this.saturation = 100;
        this.lightness -= 10;
        // Lightness below 30% is too dark
        if (this.lightness <= 30) {
          // use pastel colors
          this.lightness = 75;
        }
      }
    }

    return colorHex;
  }
}

function djb2HashStr(str) {
  str += 'ice cream'; // add a little sugar
  let hash = 5381; // djb2 magic number
  for (let i = 0; i < str.length; i++) {
    hash = hash * 33 ^ str.charCodeAt(i);
  }
  return Math.abs(hash); // convert to unsigned int
}

function generateColor(str) {
  const hash = djb2HashStr(str);

  const hue = hash % 361; // [0, 360]
  const saturation = hash % 71 + 30; // [30, 100]
  const lightness = hash % 51 + 25; // [25, 75]

  const color = new THREE.Color();
  color.setHSL(hue / 360, saturation / 100, lightness / 100); // values range [0, 1]
  return '#' + color.getHexString();
}

export function getRestrictedValueColor(dataType, allowedList = [], displayOptions, value) {
  const valueIndex = allowedList.indexOf(value);

  if (valueIndex === -1) {
    /* Extensible list item, generate color */
    return generateColor(value);
  }

  // Special case for value belonging to the list of allowed values
  // there may be displayOptions coming from the attribute definition
  const color = displayOptions?.[value]?.c;

  if (color == null) {
    // Default to a color from the palette
    // Note: contrary to non-restrictive values, the palette is not "consumed" here since we cycle through it
    const palette = dataType === AttributeType.StringList ? PALETTE_ATTRIBUTE_STRINGLIST : PALETTE_ATTRIBUTE_STRING;
    return palette[valueIndex % palette.length];
  }

  if (color !== DISPLAY_COLOR_NO_FILL) {
    return color;
  }

  return null;
}